import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import {
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  UPLOAD_ATTACHMENT_LOG_URL,
  GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
  DELETE_ATTACHMENT_LOG_BY_ID_URL,
} from "../../constants/ApiRoute";
import { authHeader, getLogUserId } from "../comman/MainFunction";
import {
  CustomMessage,
  deCryptFun,
  enCryptFun,
} from "../comman/CustomFunction";
import API from "../comman/API";
import { useToast } from "../comman/CustomMessages";
import { getUploadErrorMessage, uploadAttachmentFiles } from "./attachmentUpload";
import { DeleteIcon, DownloadIcon, EditIcon } from "../../images/SvgIcons";
import JSZip from "jszip";
import { useParams } from "react-router";
import { values } from "underscore";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const moment = require("moment");

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function BillingAttachment(props) {
  const {
    open,
    handleClose,
    billingStatementDetail,
    getInvoiceDetails,
    setOpenAttachmentFilter,
    activeStep,
    selectedNewPeriodList,
    values
  } = props;
  console.log(
    billingStatementDetail,
    selectedNewPeriodList,
    "billingStatementDetailbillingStatementDetail",
    values
  );
  const fileInputRef = useRef(null);
  const showToast = useToast();
  const theme = useTheme();
  const { id } = useParams();
  console.log(id, "invoiceNumberinvoiceNumber", useParams());
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [attachmentFile, setAttachmentFile] = React.useState([]);
  const [attachmentName, setAttachmentName] = React.useState([]);
  const [attachmentRemark, setAttachmentRemark] = React.useState("");
  const [attachmentFileObject, setAttachmentFileObject] = React.useState([]);
  const [updateCancelButton, setUpdateCancelButton] = React.useState(false);
  const [disabledEditDelete, setDisabledEditDelete] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [attachmentLoading, setAttachemntLoading] = React.useState(false);
  const [deleteDoublevalidation, setDeleteDoubleValidation] =
    React.useState(false);
  const [, setAttachementFilePath] = React.useState("");
  const [selectedAttachmentId, setSelectedAttachmentId] = useState(null);
  const [downloadLoading, setDownloadLoading] = useState(false);
  console.log(attachmentFileObject, "attachmentFileObjectattachmentFileObject");
  console.log(
    attachmentRemark,
    "attachmentRemarkattachmentRemarkattachmentRemark"
  );

  const downLoadAttachment = async () => {
    setDownloadLoading(true);
    const zip = new JSZip();
    const folder = zip.folder();

    try {
      // Fetch images and add them to the zip
      const fetchPromises = attachmentFileObject.map(async (photo, index) => {
        setDownloadLoading(true);
        try {
          const response = await fetch(photo.Path);
          if (!response.ok) {
            throw new Error(
              `Failed to fetch ${photo.Path}. Status: ${response.status}, Status Text: ${response.statusText}`
            );
          }

          const blob = await response.blob();
          let fileName = photo.FileName;

          // Check for duplicate filenames
          let duplicateCount = 0;
          const originalFileName = fileName;

          // Ensure uniqueness by appending an index if a duplicate exists
          while (folder.files[`${fileName}`]) {
            duplicateCount += 1;
            const lastDotIndex = originalFileName.lastIndexOf(".");
            const nameWithoutExt = originalFileName.substring(0, lastDotIndex);
            const ext = originalFileName.substring(lastDotIndex); // Includes the dot
            fileName = `${nameWithoutExt} (${duplicateCount})${ext}`;
          }

          // Add file to the zip with the unique file name
          folder.file(fileName, blob);
        } catch (error) {
          console.error(`Error fetching ${photo.Path}:`, error);
        }
      });

      // Wait for all fetch promises to resolve
      await Promise.all(fetchPromises);

      // Generate the zip file and save it
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `${"Invoice"}_${id}_${"Attachments"}.zip`);
    } catch (error) {
      console.error("Error generating or saving zip file:", error);
    } finally {
      setDownloadLoading(false);
    }
  };

  const handleNoRecordClick = () => {
    showToast("No attachments available to download.", "error");
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);

    if (files.length === 0) return;

    const filenames = files.map((file) => {
      let filename = file.name;
      const maxLength = 100;
      const lastDotIndex = filename.lastIndexOf(".");
      const extension =
        lastDotIndex !== -1 ? filename.substring(lastDotIndex) : "";

      if (filename.length > maxLength) {
        const previewLength = maxLength - extension.length - 3;
        filename = `${filename.substring(0, previewLength)}...${extension}`;
      }

      return filename;
    });

    setAttachmentName((previousNames) => [...previousNames, ...filenames]);
    setAttachmentFile((previousFiles) => [...previousFiles, ...files]);
    e.target.value = null;
  };

  const handleRemarkChange = (event) => {
    setAttachmentRemark(event.target.value);
  };

  const removePendingFile = (index) => {
    setAttachmentFile((files) => files.filter((_, fileIndex) => fileIndex !== index));
    setAttachmentName((names) => names.filter((_, fileIndex) => fileIndex !== index));
  };

  const handleFileUpload = async () => {
    if (!attachmentRemark) {
      showToast(
        "Cannot save file attachment. Attachment description is required.",
        "error"
      );
      return false;
    }

    if (attachmentFile.length === 0) {
      showToast(
        "Cannot save file attachment. Attachment file is required.",
        "error"
      );
      return false;
    }

    setLoading(true);
    let uploadedFiles;
    try {
      uploadedFiles = await uploadAttachmentFiles(attachmentFile);
    } catch (error) {
      // Keep the selected files so the user can retry.
      showToast(getUploadErrorMessage(error), "error");
      setLoading(false);
      return false;
    }

    // One attachment record is saved per uploaded file.
    let postObj = {
      attachmentId: 0,
      parentID: billingStatementDetail[0]?.InvoiceId || id,
      ParentTypeID: 2,
      projID: billingStatementDetail[0]?.ProjID || selectedNewPeriodList[0]?.ProjID || values.ProjectID,
      userID: getLogUserId(),
      periodKey: billingStatementDetail[0]?.PeriodKey || selectedNewPeriodList[0]?.PeriodKey || values?.InvoicePeriodKey,
      description: attachmentRemark,
      files: uploadedFiles,
    };

    const config = {
      method: "POST",
      url: UPLOAD_ATTACHMENT_LOG_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postObj)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        showToast(
          uploadedFiles.length > 1
            ? `${uploadedFiles.length} attachments uploaded successfully`
            : "Attachment uploaded successfully",
          "success"
        );
        setAttachmentFile([]);
        setAttachmentName([]);
        setAttachmentRemark("");
        const descriptionInput = document.getElementById("outlined-multiline-static");
        if (descriptionInput) descriptionInput.value = "";
      } else {
        showToast(parsedResponse.message || "Unable to save attachments.", "error");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          getInvoiceDetails();
          setOpenAttachmentFilter(false);
        } else {
          showToast(v?.message?.message || v?.message, "error");
        }
      } else {
        showToast("Unable to save attachments.", "error");
      }
    } finally {
      getAttachmentListByProjectId();
      setLoading(false);
    }
  };

  const attachmentRemoveFunction = (value) => {
    setSelectedAttachmentId(value);
    setDeleteDoubleValidation(true);
    // const updatedAttachmentFileObject = attachmentFileObject.filter(
    //   (item) => item.attachmentId !== value
    // );
    // setAttachmentFileObject(updatedAttachmentFileObject);
    // deleteAttachmentById(value);
  };

  const handleYesClick = () => {
    if (selectedAttachmentId === null) return; // Safety check

    const updatedAttachmentFileObject = attachmentFileObject.filter(
      (item) => item.attachmentId !== selectedAttachmentId
    );
    setAttachmentFileObject(updatedAttachmentFileObject);
    deleteAttachmentById(selectedAttachmentId);
    setSelectedAttachmentId(null);
    setDeleteDoubleValidation(false);
  };

  const handleNoClick = () => {
    // Close the dialog without any action
    setSelectedAttachmentId(null);
    setDeleteDoubleValidation(false);
  };

  /*
  const handleFileUploadLog = async () => {

    let successFlagCount = 0;

    for (const item of attachmentFileObject) {


      let postObj = {
        "parentID": item.parentID,
        "ParentTypeID": item.ParentTypeID,
        "projID": item.projID,
        "userID": item.userID ? Number(item.userID) : 0,
        "periodKey": item.periodKey,
        "fileName": item.fileName,
        "description": item.description,
        "path": item.path
      }

      const config = {
        method: "POST",
        url: UPLOAD_ATTACHMENT_LOG_URL,
        headers: authHeader(),
        data: {
          webString: enCryptFun(JSON.stringify(postObj)),
          flutterString: "",
        },
      };

      try {
        const response =await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          successFlagCount = successFlagCount+1
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
        }
      }
      
    }

    if(successFlagCount == attachmentFileObject.length){
     showToast
        "Attachment log added successfully",
        "success",
        enqueueSnackbar
      );
    }

    handleClose(false)

  }
*/
  // useEffect(() => {}, [bid]);

  const getAttachmentListByProjectId = async () => {
    setAttachemntLoading(true);
    const config = {
      method: "GET",
      url: GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(
          JSON.stringify({
            // projectId: billingStatementDetail[0].ProjID,
            // periodKey: billingStatementDetail[0].PeriodKey,
            // userId: billingStatementDetail[0]?.UserID,
            userId: null,
            billingStatementId: billingStatementDetail[0]?.InvoiceId || id,
            parentTypeId: 2,
          })
        ),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("parse", parsedResponse);

      if (parsedResponse.status == "Success") {
        setAttachmentFileObject(parsedResponse.data);
      }
      setAttachemntLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        //showToast(v.message, "error");
      }
      setAttachemntLoading(false);
    }
  };

  const deleteAttachmentById = async (attachmentId) => {
    const config = {
      method: "DELETE",
      url: DELETE_ATTACHMENT_LOG_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify({ attachmentId: attachmentId })),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        showToast("Attachment removed successfully", "success");
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          setOpenAttachmentFilter(false);
          getInvoiceDetails();
        } else {
          showToast(v?.message, "error");
        }
      }
    }
  };

  const handleDescriptionEdit = (description, id, filepath, FileName) => {
    // const filterDisable = attachmentFileObject?.filter((item)=> item.attachmentId === id)
    setAttachmentRemark(description);
    setUpdateCancelButton(true);
    setDisabledEditDelete(id);
    setAttachementFilePath(filepath);
    setAttachmentName(FileName ? [FileName] : []);
  };

  const handleDescCancelButton = () => {
    setUpdateCancelButton(false);
    setAttachmentRemark("");
    setDisabledEditDelete(0);
    setAttachmentName([]);
    setAttachementFilePath("");
  };

  const handleFileUpdate = async () => {
    setLoading(true);
    if (!attachmentRemark) {
      showToast(
        "Cannot save file attachment. Attachment description is required.",
        "error"
      );
      return false;
    }
    console.log(values,'valuessssssssssssssssss')
    var formData = new FormData();
    formData.append("file", attachmentFile);
    let postObj = {
      attachmentId: disabledEditDelete, //update
      parentID: billingStatementDetail[0]?.InvoiceId || id,
      ParentTypeID: 2,
      projID: billingStatementDetail[0]?.ProjID || selectedNewPeriodList[0]?.ProjID || values?.ProjectID,
      userID: billingStatementDetail[0]?.UserID,
      periodKey: billingStatementDetail?.length > 0 ? billingStatementDetail[0]?.PeriodKey : selectedNewPeriodList?.length > 0 ? selectedNewPeriodList[0]?.PeriodKey : values?.InvoicePeriodKey,
      // Edits rename one attachment; the file itself is not replaced.
      fileName: attachmentName[0] ?? "",
      description: attachmentRemark,
    };
    const config = {
      method: "POST",
      url: UPLOAD_ATTACHMENT_LOG_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postObj)),
        flutterString: "",
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        // setCustomerName(values.name);
        showToast("Description updated successfully", "success");
        getAttachmentListByProjectId();
        setAttachmentRemark("");
        setAttachementFilePath("");
        setUpdateCancelButton(false);
        setDisabledEditDelete(0);
        setAttachmentName([]);
      }
      setLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 2) {
          showToast(v?.message?.message, "error");
          setOpenAttachmentFilter(false);
          getInvoiceDetails();
        } else {
          showToast(v?.message, "error");
        }
      }
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateDescription = () => {
    handleFileUpdate();
  };

  useEffect(() => {
    if ((billingStatementDetail && billingStatementDetail[0]?.ProjID) ||  selectedNewPeriodList[0]?.ProjID || values?.ProjectID) {
      getAttachmentListByProjectId();
    }
  }, [1]);

  return (
    <React.Fragment>
      <Dialog
        className="billing-attachment-filter"
        fullScreen={fullScreen}
        open={open}
        onClose={() => handleClose()}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "16px 20px", borderBottom: "1px solid #EDEDED" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          {attachmentFileObject && attachmentFileObject.length > 0 ? (
            <Typography className="attachment-title">
              <span className="attachment-num">
                {attachmentFileObject.length}
              </span>{" "}
              attachments found
            </Typography>
          ) : (
            <Typography>
              <p className="billing-upload-title">
                No attachments found. Click the button below to upload
                attachments to this billing statement.
              </p>
            </Typography>
          )}

          {!downloadLoading &&
          attachmentFileObject &&
          attachmentFileObject?.length > 0 ? (
            <Tooltip
              className="project-tooltip"
              title="Download all attachments."
              placement="top"
            >
              <Button
                class="download-btn-billing"
                style={{ cursor: "pointer" }}
                startIcon={<DownloadIcon />}
                onClick={downLoadAttachment}
              ></Button>
            </Tooltip>
          ) : (
            // <span
            //   class="material-symbols-outlined download-btn"
            //   style={{ cursor: "pointer" }}
            //   title="download all attachments"
            //   onClick={downLoadAttachment}
            // >
            //   download
            // </span>
            // </Tooltip>
            <Tooltip
              className="project-tooltip"
              title="No attachments available to download."
              placement="top"
            >
              <Button
                className="download-btn-disable"
                sx={{ cursor: "auto", minWidth: "auto !important" }}
                startIcon={
                  <DownloadIcon
                    sx={{
                      margin: "0px !important",
                      background: "#d5d5d6",
                    }}
                  />
                }
                onClick={handleNoRecordClick}
              />
            </Tooltip>
            // <Box class="download-btn-disable" >
            //   <DownloadIcon
            //     style={{ background: "#d5d5d6 !important", important: "true" }}
            //   />
            // </Box>
            // <span
            //   class="material-symbols-outlined download-btn"
            //   style={{ background: "#c5c5c5 !important", important: "true" }}
            // >
            //   download
            // </span>
          )}
        </Stack>
        <DialogContent sx={{ pt: 0, pb: 0 }}>
          <Grid sx={{ height: "100%" }} container spacing={2}>
            <Grid
              sx={{
                borderRight: "1px solid #EDEDED",
              }}
              item
              xs={12}
              md={6}
            >
              <Box sx={{ padding: "20px 32px 20px 0px!important" }}>
                <Typography className="upload-title">
                  Upload New Attachment
                </Typography>
                <Stack
                  sx={{ mt: "19px" }}
                  direction="column"
                  spacing={1}
                  alignItems="flex-start"
                >
                  <Button
                    className={
                      activeStep == 3 || loading || disabledEditDelete != 0
                        ? "disable-choose-file"
                        : "choose-file-btn"
                    }
                    component="label"
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    disabled={
                      activeStep == 3 || disabledEditDelete != 0 || loading
                    }
                  >
                    Choose Files
                    <VisuallyHiddenInput
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      type="file"
                      multiple
                    />
                  </Button>
                  {attachmentName.length > 0 && (
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        gap: 1,
                        width: "100%",
                      }}
                    >
                      {attachmentName.map((filename, index) => (
                        <Chip
                          key={`${filename}-${index}`}
                          className="up-filename"
                          label={filename}
                          disabled={loading || updateCancelButton}
                          deleteIcon={<CancelIcon />}
                          onDelete={() => removePendingFile(index)}
                          sx={{ maxWidth: "100%" }}
                        />
                      ))}
                    </Box>
                  )}
                </Stack>
                <TextField
                  className="upload-textarea"
                  sx={{
                    width: "-webkit-fill-available",
                    marginTop: "8px",
                  }}
                  id="outlined-multiline-static"
                  multiline
                  rows={7}
                  defaultValue=""
                  value={attachmentRemark}
                  placeholder="Write Description"
                  onChange={handleRemarkChange}
                  disabled={
                    loading ||
                    activeStep == 3 ||
                    (activeStep == 3 && !updateCancelButton) ||
                    (attachmentName.length === 0 && attachmentRemark == "")
                  }
                />
                {!updateCancelButton && (
                  <Box>
                    <Button
                      className={
                        attachmentFile.length === 0 || loading
                          ? "upload-disable-file-btn"
                          : "upload-file-btn"
                      }
                      onClick={handleFileUpload}
                      variant="contained"
                      disabled={attachmentFile.length === 0 || loading}
                    >
                      {loading && (
                        <CircularProgress
                          color={"inherit"}
                          size={10}
                          sx={{ marginRight: "3px" }}
                        />
                      )}
                      Upload Files
                    </Button>
                  </Box>
                )}
                {updateCancelButton && (
                  <Stack sx={{ mt: "11px" }} spacing={2} direction="row">
                    <Button
                      // className={
                      //   !attachmentFile || loading
                      //     ? "upload-disable-file-btn"
                      //     : "primary-btn"
                      // }
                      className="primary-btn"
                      variant="contained"
                      onClick={handleUpdateDescription}
                    >
                      {loading && (
                        <CircularProgress
                          color={"inherit"}
                          size={10}
                          sx={{ marginRight: "3px" }}
                        />
                      )}
                      Update
                    </Button>
                    <Button
                      className="cancel-btn"
                      variant="contained"
                      onClick={handleDescCancelButton}
                    >
                      Cancel
                    </Button>
                  </Stack>
                )}
              </Box>
            </Grid>
            <Grid
              sx={{ padding: "20px 0px", pl: "21px !important" }}
              item
              xs={12}
              md={6}
            >
              {!attachmentLoading &&
              attachmentFileObject &&
              attachmentFileObject.length > 0 ? (
                <Box
                  sx={{
                    padding: "20px 0px !important",
                    paddingBottom: "10px !important",
                    maxHeight: "290px",
                    height: "100%",
                    overflowY: "auto",
                  }}
                >
                  {!attachmentLoading &&
                    attachmentFileObject.map(function (item, i) {
                      console.log(item, "invoicereturn");
                      return (
                        <Stack
                          direction="row"
                          spacing={1}
                          alignItems="flex-start"
                          justifyContent="space-between"
                          key={i}
                          sx={{ marginBottom: "13px" }}
                        >
                          <Box sx={{ width: "100%" }}>
                            {/* <Box
                              sx={{ display: "flex", alignItems: "flex-start" }}
                            >
                              <Checkbox
                                sx={{ p: "0", pr: "5px" }}
                                {...label}
                                defaultChecked
                              />
                              <Typography className="upload-file-name">
                                {item.FileName
                                  ? item.FileName
                                  : "No file selected"}
                              </Typography>
                            </Box> */}
                            <Typography className="upload-file-name">
                              {item.FileName ? (
                                <a
                                  href={item.Path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: "underline",
                                    color: "rgb(21 0 176)",
                                  }}
                                >
                                  {item.FileName}
                                </a>
                              ) : (
                                "No file selected"
                              )}
                            </Typography>
                            <Typography
                              // sx={{ ml: "30px" }}
                              className="upload-file-text"
                            >
                              {item.Description
                                ? item.Description
                                : "No Remarks ..."}
                            </Typography>
                            <Stack
                              sx={{ mt: "4px" }}
                              direction="row"
                              alignItems="flex-end"
                              justifyContent="space-between"
                            >
                              <Box>
                                <Button
                                  className="upload-name-btn"
                                  variant="outlined"
                                  startIcon={
                                    <span class="material-symbols-outlined">
                                      person
                                    </span>
                                  }
                                >
                                  <span style={{ lineBreak: "anywhere" }}>
                                    {item.UserName
                                      ? item.UserName
                                      : "Unknown User"}
                                  </span>
                                </Button>
                              </Box>
                              <Typography className="upload-name-btn">
                                {item.UploadDate
                                  ? moment
                                      .utc(item.UploadDate)
                                      .format("MM/DD/YYYY")
                                  : ""}
                              </Typography>
                            </Stack>
                          </Box>
                          <Box
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <IconButton
                              className={
                                activeStep == 3 || disabledEditDelete
                                  ? "disable-file-edit"
                                  : "file-edit"
                              }
                              disabled={
                                activeStep == 3 ||
                                disabledEditDelete ||
                                updateCancelButton
                              }
                              onClick={() =>
                                handleDescriptionEdit(
                                  item.Description,
                                  item?.attachmentId,
                                  item.Path,
                                  item.FileName
                                )
                              }
                              aria-label="edit"
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              className={
                                activeStep == 3 || disabledEditDelete
                                  ? "disable-file-delete"
                                  : "file-delete"
                              }
                              disabled={activeStep == 3 || disabledEditDelete}
                              onClick={() =>
                                attachmentRemoveFunction(item.attachmentId)
                              }
                              aria-label="delete"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </Stack>
                      );
                    })}
                </Box>
              ) : (
                ""
              )}
              <Button
                sx={{ mt: "8px", position: "absolute", bottom: "15px" }}
                className="cancel-btn"
                variant="contained"
                onClick={() => handleClose()}
              >
                Cancel
              </Button>
              {/* {attachmentFileObject && attachmentFileObject.length > 0 ?
              <Button className="save-btn" onClick={handleFileUploadLog} >Save</Button>
              :""} */}
            </Grid>
          </Grid>
          {deleteDoublevalidation && (
            <Dialog
              className="user-filter-popup project-filter"
              sx={{
                width: "100% !important",
                height: "100%",
                maxHeight: "fit-co",
              }}
              // fullScreen={fullScreen}
              open={open}
              //  onClose={handleChangeno}
              aria-labelledby="responsive-dialog-title"
            >
              <Stack
                sx={{ p: "25px 25px", pb: "4px" }}
                direction="row"
                alignItems="center"
                spacing={2}
                justifyContent="space-between"
              >
                <Typography className="model-title">
                  Remove Attachment
                </Typography>
              </Stack>
              <Box sx={{ p: "0px 25px 0px 25px" }}>
                <p className="label">
                  Are you sure you want to remove this attachment?
                </p>
              </Box>
              <DialogActions
                sx={{
                  justifyContent: "flex-start",
                  p: "20px 25px",
                  pt: "18px",
                }}
              >
                <Button className="filter-btn" onClick={() => handleYesClick()}>
                  Yes
                </Button>
                <Button className="cancel-btn" onClick={handleNoClick}>
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
